import type { TFunction } from 'i18next'

import type { ProductionAssignment, ProductionAssignmentItem } from '@/api/studio-production'

export type AssignmentItemLabel = {
  kindLabel: string
  title: string
}

export function assignmentItemKey(itemType: string, itemPublicId: string): string {
  return `${itemType}:${itemPublicId}`
}

export function parseShotSceneKey(
  key: string,
): { scriptId: number; episodeNo: number; sceneNo: number } | null {
  const m = /^script:(\d+):ep:(\d+):scene:(\d+)$/.exec(key.trim())
  if (!m) return null
  return {
    scriptId: Number(m[1]),
    episodeNo: Number(m[2]),
    sceneNo: Number(m[3]),
  }
}

export function resolveAssignmentItemLabel(
  item: ProductionAssignmentItem,
  resolve: (itemType: string, itemPublicId: string) => AssignmentItemLabel,
): AssignmentItemLabel {
  return resolve(item.item_type, item.item_public_id)
}

export function formatAssignmentScopeItem(
  item: ProductionAssignmentItem,
  resolve: (itemType: string, itemPublicId: string) => AssignmentItemLabel,
): string {
  const { kindLabel, title } = resolveAssignmentItemLabel(item, resolve)
  return `${kindLabel} · ${title}`
}

/** @deprecated 仅作无 production 上下文时的兜底 */
export function formatAssignmentScopeItemRaw(t: TFunction, item: ProductionAssignmentItem): string {
  return t('tasks.scopeItem', { type: item.item_type, id: item.item_public_id })
}

export function assignmentScopeLabels(
  a: ProductionAssignment,
  resolve: (itemType: string, itemPublicId: string) => AssignmentItemLabel,
): AssignmentItemLabel[] {
  return (a.items ?? []).map((it) => resolveAssignmentItemLabel(it, resolve))
}

export function aggregateQuotaByAssignee(assignments: ProductionAssignment[]) {
  const map = new Map<
    number,
    { remaining: number; allocated: number; assignmentCount: number; itemCount: number }
  >()
  for (const a of assignments) {
    const cur = map.get(a.assignee_id) ?? {
      remaining: 0,
      allocated: 0,
      assignmentCount: 0,
      itemCount: 0,
    }
    cur.remaining += a.quota_remaining
    cur.allocated += a.quota_allocated
    cur.assignmentCount += 1
    cur.itemCount += (a.items ?? []).length
    map.set(a.assignee_id, cur)
  }
  return map
}
